<div class="card-header bg-light">
  <h4 class="card-title mb-0">Vincular UG's</h4>
</div>
<div class="card-body wrapper">

  <div class="row">
    <div class="col-sm-7">
      <label for="ugs" class="form-label">Selecionar UGs</label>
      <ng-select
        placeholder="Selecionar unidades gestoras"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="ugsSelecionadas"
        (change)="onSelectionChange()"
        [multiple]="true"
        [closeOnSelect]="false"
        [clearable]="true"
        [compareWith]="compareUgs"
        [class.is-invalid]="statusError">
        <ng-option *ngFor="let item of unidadesGestoras; trackBy: trackByUgId" [value]="item">
          {{ item?.sigla }} - {{ item?.nome }}
        </ng-option>
      </ng-select>

      <!-- Exibir mensagem de erro -->
      <div *ngIf="statusError" class="invalid-feedback d-block">
        {{ statusError }}
      </div>
    </div>
  </div>

</div>
<div class="card-footer">
  <button type="submit" class="btn btn-primary btn-sm mr-1"
    (click)="salvar()">
    <i class="far fa-save"></i> Salvar
  </button>
  <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
    <i class="fas fa-times"></i> Cancelar
  </button>
</div>
